import axiosModule from "@/util/axios-module";
import { ResponseWrapper, ErrorWrapper } from "./util";

export class LabelService {
  static async GetLabels() {
    try {
      const response = await axiosModule.get("/Labels");
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async AddLabel(data) {
    try {
      const response = await axiosModule.post("/Labels", data);
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async UpdateLabel(data) {
    try {
      const response = await axiosModule.post("/Labels/update", data);
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async DeleteLabel(id) {
    try {
      const response = await axiosModule.deleteReq(`/Labels/${id}`);
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }
}
